module.exports = __webpack_public_path__ + "static/img/fenzu.6e09ae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/fenzu.png
// module id = w7YA
// module chunks = 24